export default function filtrarRegistrosPorAsesor(registros, idAsesor) {
  return registros.filter(registro => registro.uuid_asesor === idAsesor);
}